export const NavDataConfig = [
    {
        to: 'home',
        label: 'Home',
    },
    {
        to: 'about',
        label: 'About',
    },
    
    {
        to: 'services',
        label: 'Services',
    },
    {
        to: 'portfolio',
        label: 'Portfolio',
    },
    {
        to: 'faqs',
        label: 'FAQs',
    },
    {
        to: 'contact',
        label: 'Contact',
    },
]